import React from "react";
import { Link } from "react-router-dom";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import DirectionsBoatRoundedIcon from "@mui/icons-material/DirectionsBoatRounded";
import PrecisionManufacturingRoundedIcon from "@mui/icons-material/PrecisionManufacturingRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

const services = [
  {
    title: "Domestic Transport",
    description: "10ft truck, wing van, dropside and more",
    accent: "orange",
    Icon: LocalShippingRoundedIcon
  },
  {
    title: "Container Shipping",
    description: <>20ft / 40ft • FCL • LCL<br />Import &amp; Export</>,
    accent: "blue",
    Icon: Inventory2OutlinedIcon
  },
  {
    title: "Port & Yard Services",
    description: <>Empty Container Return<br />Empty Pickup</>,
    accent: "green",
    Icon: DirectionsBoatRoundedIcon
  },
  {
    title: "Special Cargo",
    description: <>Heavy • Oversized • Project Cargo • RORO</>,
    accent: "purple",
    Icon: PrecisionManufacturingRoundedIcon
  },
  {
    title: "Additional Services",
    description: <>Warehousing • Customs Documentation • Cargo Handling</>,
    accent: "coral",
    Icon: WarehouseRoundedIcon
  }
];

export default function ServicesSection() {
  return (
    <section className="pl-services pl-section pl-reveal" id="services" aria-labelledby="pl-services-title">
      <div className="pl-container">
        <div className="pl-section-heading">
          <div>
            <p className="pl-eyebrow">Our services</p>
            <h2 id="pl-services-title">Complete Logistics Solutions</h2>
            <p>From local deliveries to international shipments, Garahex connects you with reliable transport providers for every cargo need.</p>
          </div>
          <a className="pl-text-link" href="#quick-quote">
            View All Services <ArrowForwardRoundedIcon aria-hidden="true" />
          </a>
        </div>

        <div className="pl-service-grid">
          {services.map(({ title, description, accent, Icon }) => (
            <article className={`pl-service-card pl-service-card--${accent}`} key={title}>
              <span className="pl-service-card__icon"><Icon aria-hidden="true" /></span>
              <h3>{title}</h3>
              <p>{description}</p>
              {/* Dedicated public service-detail routes are not present in the accepted frontend. */}
              <Link to="/contact-us">
                Learn More <ArrowForwardRoundedIcon aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
